import { gql } from '@apollo/client';
import {
  ATTRUBUTE_BASIC_FRAGMENT,
  ATTRUBUTE_VALUE_BASIC_FRAGMENT,
} from './attributeFragments';

export const PRODUCT_VARIANT_BASIC_FRAGMENT = gql`
  fragment ProductVariantBasic on ProductVariant {
    id
    name
    availability
    labels(first: 10) {
      edges {
        node {
          id
          name
          color
          content
          description
          backgroundColor
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
    sku
    media {
      id
      alt
      url(size: 3000)
    }
    pricing {
      price {
        net {
          currency
          amount
        }
      }
      percentageDiscountAmount
      priceUndiscounted {
        net {
          currency
          amount
        }
      }
      discount {
        net {
          currency
          amount
        }
      }
      installmentPrice4 {
        currency
        amount
      }
      installmentPrice6 {
        currency
        amount
      }
      installmentPrice12 {
        currency
        amount
      }
      bonusesAmount
    }
    attributes {
      attribute {
        ...AttributeBasic
      }
      values {
        ...AttributeValueBasic
      }
    }
    attributesCategories {
      id
      name
      description
    }
    channelListings {
      id
      installment {
        partner {
          id
          name
          logo
          partnerName
          isActive
          sortOrder
          isOwn
          externalPartnerName
        }
        months {
          monthsAmount
          totalPrice {
            currency
            amount
          }
        }
      }
    }
    product {
      id
      name
      slug
      variants {
        id
        name
        sku
        trackInventory
        quantityLimitPerCustomer
      }
      category {
        id
        name
        slug
        description
        icon
        level
        isActive
        isInCatalog
        isBottom
        isPopular
        parent {
          id
          name
          slug
          icon
          level
          isActive
          isInCatalog
          isPopular
          isBottom
        }
        ancestors(first: 10) {
          edges {
            node {
              id
              description
              name
              slug
              level
            }
          }
        }
      }
      brand {
        id
        name
        image
        description
        isActive
        isRecommended
      }
      reviews(first: 10) {
        totalCount
      }
      attributes {
        attribute {
          ...AttributeBasic
        }
        values {
          ...AttributeValueBasic
        }
      }
    }
    gifts {
      id
      name
      product {
        id
        name
        slug
        category {
          id
          name
          slug
        }
      }
      giftsPrice {
        currency
        amount
      }
      media {
        id
        alt
        url(size: 3000)
      }
    }
  }
  ${ATTRUBUTE_BASIC_FRAGMENT}
  ${ATTRUBUTE_VALUE_BASIC_FRAGMENT}
`;

export const PRODUCT_VARIANT_BASIC_FRAGMENT_NOT_TOKEN = gql`
  fragment ProductVariantBasicNotToken on ProductVariant {
    id
    name
    availability
    labels(first: 10) {
      edges {
        node {
          id
          name
          color
          content
          description
          backgroundColor
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
    sku
    media {
      id
      alt
      url(size: 3000)
    }
    pricing {
      price {
        net {
          currency
          amount
        }
      }
      percentageDiscountAmount
      priceUndiscounted {
        net {
          currency
          amount
        }
      }
      discount {
        net {
          currency
          amount
        }
      }
      installmentPrice4 {
        currency
        amount
      }
      installmentPrice6 {
        currency
        amount
      }
      installmentPrice12 {
        currency
        amount
      }
      bonusesAmount
    }
    attributes {
      attribute {
        ...AttributeBasic
      }
      values {
        ...AttributeValueBasic
      }
    }
    attributesCategories {
      id
      name
      description
    }
    product {
      id
      name
      slug
      variants {
        id
        name
        sku
        trackInventory
        quantityLimitPerCustomer
      }
      category {
        id
        name
        slug
        description
        icon
        level
        isActive
        isInCatalog
        isBottom
        isPopular
        parent {
          id
          name

          slug
          icon
          level
          isActive
          isInCatalog
          isPopular
          isBottom
        }
        ancestors(first: 10) {
          edges {
            node {
              id
              description
              name
              slug
              level
            }
          }
        }
      }
      brand {
        id
        name
        image
        description
        isActive
        isRecommended
      }
      reviews(first: 10) {
        totalCount
      }
      attributes {
        attribute {
          ...AttributeBasic
        }
        values {
          ...AttributeValueBasic
        }
      }
    }
    gifts {
      id
      name
      product {
        id
        name
        slug
        category {
          id
          name
          slug
        }
      }
      giftsPrice {
        currency
        amount
      }
      media {
        id
        alt
        url(size: 3000)
      }
    }
  }
  ${ATTRUBUTE_BASIC_FRAGMENT}
  ${ATTRUBUTE_VALUE_BASIC_FRAGMENT}
`;

export const PRODUCT_VARIANT_BASIC_TRASNLATIONS_FRAGMENT = gql`
  fragment ProductVariantTranslationsBasic on ProductVariant {
    id
    name
    availability
    seoTitle
    metaDescription
    translation(languageCode: $languageCode) {
      name
    }
    stocks {
      id
      warehouse {
        id
        name
        store {
          id
          address {
            city
          }
        }
      }
      productVariant {
        id
        name
        sku
        translation(languageCode: $languageCode) {
          name
        }
      }
      quantity
      quantityAllocated
      quantityReserved
    }

    labels(first: 10) {
      edges {
        node {
          id
          name
          color
          backgroundColor
          content
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
    sku
    media {
      id
      alt
      url(size: 3000)
    }
    selectionAttributes: attributes(variantSelection: VARIANT_SELECTION) {
      attribute {
        ...AttributeBasic
      }
      values {
        ...AttributeValueBasic
      }
    }
    pricing {
      price {
        net {
          currency
          amount
        }
      }
      percentageDiscountAmount
      priceUndiscounted {
        net {
          currency
          amount
        }
      }
      discount {
        net {
          currency
          amount
        }
      }
      installmentPrice4 {
        currency
        amount
      }
      installmentPrice6 {
        currency
        amount
      }
      installmentPrice12 {
        currency
        amount
      }
      bonusesAmount
    }
    attributes {
      attribute {
        ...AttributeBasicTranslation
        translation(languageCode: $languageCode) {
          id
          name
          language {
            code
            language
          }
        }
      }
      values {
        ...AttributeValueBasicTranslation
        translation(languageCode: $languageCode) {
          id
          name
          language {
            code
            language
          }
        }
      }
    }
    attributesCategories {
      id
      name
      translation(languageCode: $languageCode) {
        id
        name
        language {
          code
          language
        }
      }
      description
    }
    channelListings {
      id
      installment {
        partner {
          id
          name
          translation(languageCode: $languageCode) {
            name
          }
          logo
          partnerName
          isActive
          sortOrder
          isOwn
          externalPartnerName
        }
        months {
          monthsAmount
          totalPrice {
            currency
            amount
          }
        }
      }
    }
    product {
      id
      name
      slug
      translation(languageCode: $languageCode) {
        name
      }
      variants {
        id
        name
        translation(languageCode: $languageCode) {
          name
        }
        sku
        trackInventory
        quantityLimitPerCustomer
      }
      category {
        id
        name
        slug
        description
        icon
        level
        isActive
        isInCatalog
        isBottom
        isPopular
        translation(languageCode: $languageCode) {
          name
        }
        parent {
          id
          name
          translation(languageCode: $languageCode) {
            name
          }
          slug
          icon
          level
          isActive
          isInCatalog
          isPopular
          isBottom
        }
        ancestors(first: 10) {
          edges {
            node {
              id
              description
              name
              slug
              level
              translation(languageCode: $languageCode) {
                name
              }
            }
          }
        }
      }
      brand {
        id
        name
        image
        description
        isActive
        isRecommended
        translation(languageCode: $languageCode) {
          name
        }
      }
      reviews(first: 10) {
        totalCount
      }
      attributes {
        attribute {
          ...AttributeBasic
          translation(languageCode: $languageCode) {
            name
          }
        }
        values {
          ...AttributeValueBasic
          translation(languageCode: $languageCode) {
            name
          }
        }
      }
    }
    gifts {
      id
      name
      translation(languageCode: $languageCode) {
        name
      }
      product {
        id
        name
        slug
      }
      media {
        id
        alt
        url(size: 3000)
      }
    }
  }
  ${ATTRUBUTE_BASIC_FRAGMENT}
  ${ATTRUBUTE_VALUE_BASIC_FRAGMENT}
`;

export const fragmentSticker = gql`
  fragment Sticker on ProductVariantLabel {
    id
    name
    content
    description
    color
    isActive
    backgroundColor
  }
`;
